export default __webpack_public_path__ + "static/media/photo--sm--73.69057d61.jpg";